import { ChangeDetectorRef, Component, ElementRef, forwardRef, Input, Renderer2 } from '@angular/core';

import { ToastComponent, ToasterService, ToastHeaderComponent, ToastBodyComponent, ToastCloseDirective, ProgressBarDirective, ProgressComponent } from '@coreui/angular';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    providers: [{ provide: ToastComponent, useExisting: forwardRef(() => AppToastSimpleComponent) }],
    standalone: true,
    imports: [ToastHeaderComponent, ToastBodyComponent, ToastCloseDirective/*, ProgressBarDirective, ProgressComponent*/]
})
export class AppToastSimpleComponent extends ToastComponent {

   closeButton = false;
   title = '';
   message = "";

  constructor(
    public override hostElement: ElementRef,
    public override renderer: Renderer2,
    public override toasterService: ToasterService,
    public override changeDetectorRef: ChangeDetectorRef
  ) {
    super(hostElement, renderer, toasterService, changeDetectorRef);
  }
}
